var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "boss-main-container" }, [
    _c(
      "div",
      { staticClass: "boss-main-wrap boss-main-content-wrap" },
      [
        _c("setting-header", {
          attrs: {
            breadcrumbs: [
              {
                name: "一次面接候補日設定",
                pathName: "interviewCandidateDateTop",
              },
            ],
            title: "応募者への表示日程の編集",
            "data-test": "title",
          },
        }),
        _vm._v(" "),
        _c("form-item", {
          attrs: {
            label: "カレンダー名",
            "class-name": "boss-interview-candidate-date-edit-schedule-name",
            "is-required": "",
          },
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function () {
                return [_c("small", [_vm._v("10文字以内")])]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.schedule.name,
            callback: function ($$v) {
              _vm.$set(_vm.schedule, "name", $$v)
            },
            expression: "schedule.name",
          },
        }),
        _vm._v(" "),
        _c("form-label", {
          attrs: { label: "応募者に表示する日程" },
          scopedSlots: _vm._u([
            {
              key: "body",
              fn: function () {
                return [
                  _vm._v("\n        応募当日から\n        "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.schedule.startDay,
                          expression: "schedule.startDay",
                        },
                      ],
                      staticClass: "boss-input-select",
                      attrs: { "data-test": "schedule-start-day" },
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.schedule,
                            "startDay",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    _vm._l(_vm.startDayOptions, function (startDay, i) {
                      return _c(
                        "option",
                        { key: i, domProps: { value: startDay } },
                        [
                          _vm._v(
                            "\n            " + _vm._s(startDay) + "\n          "
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v("\n        日後以降\n      "),
                ]
              },
              proxy: true,
            },
          ]),
        }),
        _vm._v(" "),
        _c("form-label", {
          attrs: { label: "曜日一括NG設定" },
          scopedSlots: _vm._u([
            {
              key: "body",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "display-flex" },
                    [
                      _vm._l(_vm.week, function (day, i) {
                        return _c(
                          "div",
                          {
                            key: i,
                            staticClass:
                              "boss-interview-candidate-date-edit-schedule-week",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "boss-interview-candidate-date-edit-schedule-week-day",
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    key: i,
                                    staticClass:
                                      "boss-button boss-button-new boss-min-width-3em",
                                    attrs: {
                                      "data-test": "all-ng-button-" + i,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.switchNgDayOfWeek(i)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(day) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "boss-interview-candidate-date-edit-schedule-week align-middle",
                          attrs: { "data-test": "week-ng-text" },
                        },
                        [
                          _vm._v(
                            "\n            ※設定時点で表示されているカレンダーのみ適用されます。\n          "
                          ),
                        ]
                      ),
                    ],
                    2
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        }),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "boss-interview-candidate-date-edit-calendar" },
          [
            _c("interview-candidate-date-calendar", {
              attrs: { schedule: _vm.schedule },
              on: { changeNgDateCalendarEdit: _vm.changeNgDate },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "boss-interview-candidate-date-edit-update" },
          [
            _c(
              "button",
              {
                staticClass:
                  "boss-button boss-interview-candidate-date-edit-update-button pega-button",
                attrs: {
                  disabled: _vm.isSubmitButtonDisabled,
                  "data-test": "submit-button",
                },
                on: { click: _vm.submit },
              },
              [_vm._v("\n        登録\n      ")]
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "boss-interview-candidate-date-edit-explain-wrap" },
      [
        _c(
          "div",
          { staticClass: "boss-interview-candidate-date-edit-explain-parent" },
          [
            _c("div", { staticClass: "boss-calendar-date-candidate" }),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass: "boss-interview-candidate-date-edit-explain-text",
                attrs: { "data-test": "candidate-text" },
              },
              [
                _vm._v(
                  "\n          応募者へ表示される一次面接候補日です。\n        "
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "boss-interview-candidate-date-edit-explain-parent" },
          [
            _c("div", {
              staticClass:
                "boss-interview-candidate-date-edit-ng-explain boss-calendar-date-ng",
            }),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass: "boss-interview-candidate-date-edit-explain-text",
                attrs: { "data-test": "ng-text" },
              },
              [
                _vm._v(
                  "\n          日付をクリックするとNG日程の選択・解除ができます。\n        "
                ),
              ]
            ),
          ]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }